import {parseConfiguration} from '../configurator.js';
import {fetchProductConfiguration, publishProductConfiguration} from './product-configurator';
import {prepareSwitcherPublication} from './product-switcher';
import {fetchDisclaimersByHandles} from './disclaimers';
import {pageSettings} from '../page-settings.js';

export async function publishProductPage(product: any, switcher: any) {
  if (!product.savedDraft || JSON.stringify(product.configuration) !== product.savedConfiguration) throw new Error('Save your draft before publishing.');
  parseConfiguration(product.savedDraft);
  if ((product.savedDraft.productGroupHandle || '') !== (switcher?.selectedHandle || '')) throw new Error('Save the selected group before publishing.');
  // Check the product before changing shared data; final metafieldsSet still uses CAS.
  const fresh = await fetchProductConfiguration(product.id);
  for (const key of ['settings', 'component_variants', 'settings_draft', 'component_variants_draft']) {
    if (fresh.digests[key] !== product.digests[key]) throw new Error('Product configuration changed in another tab. Reload before publishing.');
  }
  const settings = pageSettings(product.savedDraft);
  const ids = product.savedDraft.disclaimerHandles || [];
  if (settings.requireTermsAcceptance && !ids.length) throw new Error('Add at least one notice before requiring terms acceptance.');
  if (ids.length) {
    const notices = await fetchDisclaimersByHandles(ids);
    if (notices.length !== ids.length || notices.some((notice: any) => !notice.name.trim() || !notice.text.trim())) {
      throw new Error('A notice is missing or has empty content. Edit or remove it before publishing.');
    }
  }
  const group = await prepareSwitcherPublication(switcher);
  try {
    const configuration = structuredClone(product.savedDraft);
    delete configuration.productSwitcherDraft;
    return await publishProductConfiguration({...product, configuration, savedDraft: configuration, savedConfiguration: JSON.stringify(configuration)});
  } catch (error) {
    if (group.sharedChanged) throw new Error(`The shared group was updated, but this product’s publication did not finish. Your saved draft is retained. Reload and retry. ${error instanceof Error ? error.message : ''}`);
    throw error;
  }
}
